import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { withSpinner } from '../../extensions/withSpinner.extension';
import { API_ROOT } from '../../types/constants/appconstants';
import { TodaysScheduleUserCommunity } from '../../types/todaysscheduleusercommunity';
import { Community } from '../../types/organization';

@Injectable({
    "providedIn": "root"
})

export class TodaysScheduleService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private todayScheduleUserCommunityBaseUrl = this.apiRoot + 'api/todayscheduleusercommunities';

    GetCommunitiesForTodaysScheduleUser(marketId: number = 0): Observable<Community[]> {
        return withSpinner(this.http).get<Community[]>(this.todayScheduleUserCommunityBaseUrl + '/communitiesfortodaysscheduleuser/' + marketId);
    }

    SaveTodaysScheduleUserCommunities(todaysScheduleUserCommunities: TodaysScheduleUserCommunity[]): Observable<TodaysScheduleUserCommunity[]> {
        return withSpinner(this.http).post<TodaysScheduleUserCommunity[]>(`${this.todayScheduleUserCommunityBaseUrl}`, todaysScheduleUserCommunities);
    }

    DeleteTodaysScheduleUserCommunities(communityIds: number[]): Observable<boolean> {
        return withSpinner(this.http).delete<boolean>(`${this.todayScheduleUserCommunityBaseUrl}/deletetodaysscheduleUsercomms`, {body: { communityIds: communityIds }});
    }
}
